import memoizeWithIdentity from "ramda-extension/es/memoizeWithIdentity";
const anyCharButT = /[A-SU-Za-su-z]+/;
/*
  MomentJS did not have issue with formats containing D/Y, but date-fns require lowercase values
  https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
  date-fns also does not allow T in the format string if it does not stand for timestamp -> we have to escape it
  https://github.com/date-fns/date-fns/issues/1643
 */ const convertDateFormat = memoizeWithIdentity((dateFormat)=>{
    let finalFormat = dateFormat;
    if (finalFormat.includes('D') || finalFormat.includes('Y')) {
        const lowerD = finalFormat.replaceAll('D', 'd');
        finalFormat = lowerD.replaceAll('Y', 'y');
    }
    if (finalFormat.includes('T') && anyCharButT.test(finalFormat)) {
        finalFormat = finalFormat.replaceAll('T', "'T'");
    }
    return finalFormat;
});
export default convertDateFormat;
